import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'dialog-dashboard-new',
    templateUrl: 'dialog-dashboard-new.html',
    styleUrls: ['./dialog-dashboard-new.scss'],
    standalone: false
})
export class DialogDashboardNew {
  constructor(
    public dialogRef: MatDialogRef<DialogDashboardNew>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void { 
    this.data = { name: "", isPublic: false };
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  setPrivate() {
    this.data.isPublic = false;
  }

  setPublic() {
    this.data.isPublic = true;
  }
}
